export default {
  modal: {
    show: false,
  },
  tabView: {
    itemActive: 0,
    canAddServices: false,
    canClickAccept: false,
  },
};
